import { AxiosError } from "axios";
import {
  CallWindowT,
  RankedCallsQueryI,
  TopCallsQueryI,
  TopTenCallsQueryI,
} from "@/api/routes/top-calls";

export const CALL_WINDOWS = ["7", "30", "90", "lifetime"] as const;
export const isCallGateLocked = (error: unknown): boolean => {
  const response = (error as AxiosError<{ error_code?: number }>)?.response;

  return response?.status === 403 && response.data?.error_code === 12001;
};

export const rankedCallsQuery = (
  query: TopCallsQueryI,
  window: CallWindowT
): RankedCallsQueryI => {
  const result: RankedCallsQueryI = { ...query, window };
  delete result.view;

  return result;
};

export const topTenCallsQuery = (
  query: TopCallsQueryI,
  window: CallWindowT
): TopTenCallsQueryI => {
  const { limit: _limit, cursor: _cursor, ...filters } = query;

  return { ...filters, window };
};

// Copy the supplied scoring configuration's grade bands without changing colors.
export const gradeColor = (grade: string | null | undefined): string => {
  switch (grade?.[0]) {
    case "A":
      return "#16a34a";
    case "B":
      return "#2563eb";
    case "C":
      return "#f59e0b";
    case "D":
      return "#ea580c";
    case "F":
      return "#dc2626";
    default:
      return "#9ca3af";
  }
};
